// src/routes.js
import Dashboard from '@pages/Dashboard';
import Profile from '@pages/profile/Profile';
import Account from '@pages/account/Account';
import AccountAdd from '@pages/account/AccountAdd';
import AccountEdit from '@pages/account/AccountEdit';
import EmailConfig from '@pages/emailConfig/EmailConfig';
import EmailConfigAdd from '@pages/emailConfig/EmailConfigAdd';
import EmailConfigEdit from '@pages/emailConfig/EmailConfigEdit';
import LoginHistory from '@app/pages/report/countLogin/LoginHistory';
import StatisticLoginHistory from '@app/pages/report/countLogin/StatisticLoginHistory';
import Log from '@pages/log/Log';
import ApiRoleMapping from '@app/pages/apiRoleMapping/ApiRoleMapping';
import ApiRoleMappingAdd from '@app/pages/apiRoleMapping/ApiRoleMappingAdd';
import ApiRoleMappingEdit from '@app/pages/apiRoleMapping/ApiRoleMappingEdit';

import {URI_INTERNAL} from './utils/pathLocations';
import OpeniddictApplication from '@app/pages/openiddictApplication/OpeniddictApplication';
import OpeniddictApplicationAdd from '@app/pages/openiddictApplication/OpeniddictApplicationAdd';
import OpeniddictApplicationEdit from '@app/pages/openiddictApplication/OpeniddictApplicationEdit';
import RoleAccount from '@app/pages/roleAccount/RoleAccount';
import RoleAccountAdd from '@app/pages/roleAccount/RoleAccountAdd';
import RoleAccountEdit from '@app/pages/roleAccount/RoleAccountEdit';
import Department from '@app/pages/department/Department';
import DepartmentAdd from '@app/pages/department/DepartmentAdd';
import DepartmentEdit from '@app/pages/department/DepartmentEdit';
import MaterialCatalog from '@app/pages/materialCatalog/MaterialCatalog';
import MaterialCatalogAdd from '@app/pages/materialCatalog/MaterialCatalogAdd';
import MaterialCatalogEdit from '@app/pages/materialCatalog/MaterialCatalogEdit';

import MaintenanceBatchList from '@app/pages/maintenanceEvent/MaintenanceBatchList';
import MaintenanceBatchAdd from '@app/pages/maintenanceEvent/MaintenanceBatchAdd';
import MaintenanceBatchDetail from '@app/pages/maintenanceEvent/MaintenanceBatchDetail';

import AssetTransferList from '@app/pages/assetTransfer/AssetTransferList';
import AssetStatus from '@app/pages/assetStatus/AssetStatus';
import AssetStatusAdd from '@app/pages/assetStatus/AssetStatusAdd';
import AssetStatusEdit from '@app/pages/assetStatus/AssetStatusEdit';
import AssetGroup from '@app/pages/assetGroup/AssetGroup';
import AssetGroupAdd from '@app/pages/assetGroup/AssetGroupAdd';
import AssetGroupEdit from '@app/pages/assetGroup/AssetGroupEdit';
import Asset from '@app/pages/asset/Asset';
import AssetAdd from '@app/pages/asset/AssetAdd';
import AssetEdit from '@app/pages/asset/AssetEdit';
import AssetTransfer from '@app/pages/asset/AssetTransfer';

const rawRoutes = [
    // dashboard
    {
        path: '/', // bạn có thể thêm HOME_PATH = '/'
        exact: true,
        component: Dashboard,
        isPublic: false,
        // label:      'Dashboard',
        controller: '',
        action: '',
        label: 'Dashboard',
        menu: true,
        isPublic: false
    },
    // profile
    {
        path: '/profile',
        exact: true,
        component: Profile,
        isPublic: false,
        // controller: 'Profile',
        // action:     'View',
        // label:      'Profile',
        controller: '',
        action: '',
        label: 'Thông tin cá nhân',
        menu: false,
        isPublic: false
    },
    // account
    {
        path: URI_INTERNAL.ACCOUNT_PATH,
        exact: true,
        component: Account,
        isPublic: false,
        controller: 'Account',
        // controller: '',
        action: '',
        label: 'Tài khoản',
        menu: true,
        isPublic: false
    },
    {
        path: URI_INTERNAL.ACCOUNT_PATH_ADD,
        exact: true,
        component: AccountAdd,
        isPublic: false,
        // controller: 'Account',
        controller: '',
        action: '',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.ACCOUNT_PATH_EDIT,
        exact: true,
        component: AccountEdit,
        isPublic: false,
        // controller: 'Account',
        controller: '',
        action: '',
        label: '',
        menu: false,
        isPublic: false
    },
    //role
    {
        path: URI_INTERNAL.ROLE_ACCOUNT_PATH,
        exact: true,
        component: RoleAccount,
        isPublic: false,
        controller: 'Role',
        // controller: '',
        action: '',
        label: 'Quyền',
        menu: true,
        isPublic: false
    },
    {
        path: URI_INTERNAL.ROLE_ACCOUNT_CREATE_PATH,
        exact: true,
        component: RoleAccountAdd,
        isPublic: false,
        // controller: 'Account',
        controller: '',
        action: '',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.ROLE_ACCOUNT_EDIT_PATH,
        exact: true,
        component: RoleAccountEdit,
        isPublic: false,
        // controller: 'Account',
        controller: '',
        action: '',
        label: '',
        menu: false,
        isPublic: false
    },
    // email config
    {
        path: URI_INTERNAL.EMAILCONFIG_PATH,
        exact: true,
        component: EmailConfig,
        isPublic: false,
        controller: 'EmailConfig',
        // controller: '',
        action: '',
        label: 'Email gửi thông báo',
        menu: true,
        isPublic: false
    },
    {
        path: URI_INTERNAL.EMAILCONFIG_CREATE_PATH,
        exact: true,
        component: EmailConfigAdd,
        isPublic: false,
        // controller: 'EmailConfig',
        controller: '',
        action: '',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.EMAILCONFIG_EDIT_PATH,
        exact: true,
        component: EmailConfigEdit,
        isPublic: false,
        // controller: 'EmailConfig',
        controller: '',
        action: '',
        label: '',
        menu: false,
        isPublic: false
    },
    // reports
    {
        path: URI_INTERNAL.LOGIN_HISTORY_PATH,
        exact: true,
        component: LoginHistory,
        isPublic: false,
        controller: 'LoginHistory',
        // controller: '',
        action: '',
        label: 'Lịch sử đăng nhập',
        menu: true,
        isPublic: false
    },
    {
        path: URI_INTERNAL.STATISTIC_HISTORY_PATH,
        exact: true,
        component: StatisticLoginHistory,
        isPublic: false,
        // controller: 'Report',
        controller: '',
        action: '',
        label: 'Thống kê lịch sử đăng nhập',
        menu: true,
        isPublic: false
    },
    // api-role-mapping
    {
        path: URI_INTERNAL.APIROLEMAPPING_PATH,
        exact: true,
        component: ApiRoleMapping,
        isPublic: false,
        controller: 'ApiRoleMapping',
        // controller: '',
        action: '',
        label: 'Phân quyền API',
        menu: true,
        isPublic: false
    },
    {
        path: URI_INTERNAL.APIROLEMAPPING_CREATE_PATH,
        exact: true,
        component: ApiRoleMappingAdd,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Them',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.APIROLEMAPPING_EDIT_PATH,
        exact: true,
        component: ApiRoleMappingEdit,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Sua',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.OPENIDDICTAPPLICATION_PATH,
        exact: true,
        component: OpeniddictApplication,
        isPublic: false,
        controller: 'OpeniddictApplication',
        // controller: '',
        action: '',
        label: 'Ứng dụng đăng ký',
        menu: true,
        isPublic: false
    },
    {
        path: URI_INTERNAL.OPENIDDICTAPPLICATION_CREATE_PATH,
        exact: true,
        component: OpeniddictApplicationAdd,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Them',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.OPENIDDICTAPPLICATION_EDIT_PATH,
        exact: true,
        component: OpeniddictApplicationEdit,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Sua',
        label: '',
        menu: false,
        isPublic: false
    },
    // log
    {
        path: URI_INTERNAL.LOG_PATH,
        exact: true,
        component: Log,
        isPublic: false,
        controller: 'Log',
        // controller: '',
        action: '',
        label: 'Xem log',
        menu: true,
        isPublic: false
    },
    {
        path: URI_INTERNAL.DEPARTMENT_PATH,
        exact: true,
        component: Department,
        isPublic: false,
        controller: 'Department',
        // controller: '',
        action: '',
        label: 'Đơn vị',
        menu: true,
        isPublic: false
    },
    {
        path: URI_INTERNAL.DEPARTMENT_CREATE_PATH,
        exact: true,
        component: DepartmentAdd,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Them',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.DEPARTMENT_EDIT_PATH,
        exact: true,
        component: DepartmentEdit,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Sua',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.MATERIALCATALOG_PATH,
        exact: true,
        component: MaterialCatalog,
        isPublic: false,
        controller: 'MaterialCatalog',
        // controller: '',
        action: '',
        label: 'Vật tư / linh kiện',
        menu: true,
        isPublic: false
    },
    {
        path: URI_INTERNAL.MATERIALCATALOG_CREATE_PATH,
        exact: true,
        component: MaterialCatalogAdd,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Them',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.MATERIALCATALOG_EDIT_PATH,
        exact: true,
        component: MaterialCatalogEdit,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Sua',
        label: '',
        menu: false,
        isPublic: false
    },



    // {
    //   path: URI_INTERNAL.ASSETTRANSFER_CREATE_PATH,
    //   exact: true,
    //   component: AssetTransferAdd,
    //   isPublic: false,
    //   // controller: 'AssetTransfer',
    //   // action:     'Them',
    //   label: "",
    //   menu:       false,
    //   isPublic: false,
    // },
    // {
    //   path: URI_INTERNAL.ASSETTRANSFER_EDIT_PATH,
    //   exact: true,
    //   component: AssetTransferEdit,
    //   isPublic: false,
    //   // controller: 'AssetTransfer',
    //   // action:     'Sua',
    //   label: "",
    //   menu:       false,
    //   isPublic: false,
    // },

    // asset status
    {
        path: URI_INTERNAL.ASSETSTATUS_PATH,
        exact: true,
        component: AssetStatus,
        isPublic: false,
        controller: 'AssetStatus',
        // controller: '',
        action: '',
        label: 'Trạng thái tài sản',
        menu: true,
        isPublic: false
    },
    {
        path: URI_INTERNAL.ASSETSTATUS_CREATE_PATH,
        exact: true,
        component: AssetStatusAdd,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Them',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.ASSETSTATUS_EDIT_PATH,
        exact: true,
        component: AssetStatusEdit,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Sua',
        label: '',
        menu: false,
        isPublic: false
    },
    // asset group
    {
        path: URI_INTERNAL.ASSETGROUP_PATH,
        exact: true,
        component: AssetGroup,
        isPublic: false,
        controller: 'AssetGroup',
        // controller: '',
        action: '',
        label: 'Nhóm tài sản',
        menu: true,
        isPublic: false
    },
    {
        path: URI_INTERNAL.ASSETGROUP_CREATE_PATH,
        exact: true,
        component: AssetGroupAdd,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Them',
        label: '',
        menu: false,
        isPublic: false
    },
    {
        path: URI_INTERNAL.ASSETGROUP_EDIT_PATH,
        exact: true,
        component: AssetGroupEdit,
        isPublic: false,
        // controller: 'ApiRoleMapping',
        // action:     'Sua',
        label: '',
        menu: false,
        isPublic: false
    },
    // asset
    {
        path: URI_INTERNAL.ASSET_PATH,
        exact: true,
        component: Asset,
        isPublic: false,
        controller: 'Asset',
        action: '',
        label: 'Tài sản',
        menu: true
    },
    {
        path: URI_INTERNAL.ASSET_CREATE_PATH,
        exact: true,
        component: AssetAdd,
        isPublic: false,
        label: '',
        menu: false
    },
    {
        path: URI_INTERNAL.ASSET_EDIT_PATH,
        exact: true,
        component: AssetEdit,
        isPublic: false,
        label: '',
        menu: false
    },
    {
        path: URI_INTERNAL.ASSET_TRANSFER_PATH,
        exact: true,
        component: AssetTransfer,
        isPublic: false,
        label: '',
        menu: false
    },
    {
        path: URI_INTERNAL.ASSETTRANSFER_LIST_PATH,
        exact: true,
        component: AssetTransferList,
        isPublic: false,
        controller: 'AssetTransfer',
        // controller: '',
        action: '',
        label: 'Danh sách điều chuyển',
        menu: true,
        isPublic: false
    },
    {
        path: URI_INTERNAL.MAINTENANCE_BATCH_PATH,
        exact: true,
        component: MaintenanceBatchList,
        isPublic: false,
        controller: 'AssetMaintenanceEvent',
        action: '',
        label: 'Phiếu sửa chữa',
        menu: true,
        isPublic: false
    },
    {
        path: URI_INTERNAL.MAINTENANCE_BATCH_CREATE_PATH,
        exact: true,
        component: MaintenanceBatchAdd,
        isPublic: false,
        controller: 'AssetMaintenanceEvent',
        label: '',
        menu: false
    },
    {
        path: URI_INTERNAL.MAINTENANCE_BATCH_DETAIL_PATH,
        exact: true,
        component: MaintenanceBatchDetail,
        isPublic: false,
        controller: 'AssetMaintenanceEvent',
        label: '',
        menu: false
    }
];

// function withController(routes) {
//   return routes.map(r => {
//     const name = r.component.displayName || r.component.name || '';
//     return {
//       ...r,
//       controller: r.controller ? r.controller : name,
//       // nếu chưa có label thì lấy tên component
//       label: r.label || name,
//     };
//   });
// }

function withController(routes) {
    return routes.map((r) => ({
        ...r,
        // controller: r.controller,
        label: r.label || r.controller
    }));
}

export const appRoutes = withController(rawRoutes);

export const menuGroups = [
    {
        title: 'Hệ thống',
        icon: 'fas fa-cog',
        // Lấy tất cả route menu thuộc nhóm Hệ thống
        children: appRoutes.filter(
            (r) =>
                r.menu &&
                [
                    'Account',
                    'Role',
                    'EmailConfig',
                    'ApiRoleMapping',
                    'OpeniddictApplication',
                    'Log'
                ].includes(r.controller)
        )
    },
    {
        title: 'Chức năng',
        icon: 'fas fa-cog',
        children: appRoutes.filter(
            (r) =>
                r.menu &&
                [
                    'Department',
                    'MaterialCatalog',
                    'AssetStatus',
                    'AssetGroup',
                    'Asset',
                    'AssetTransfer',
                    'AssetMaintenanceEvent'
                ].includes(r.controller)
        )
    },
    {
        title: 'Báo cáo',
        icon: 'fas fa-table',
        // Lấy tất cả route menu thuộc nhóm Báo cáo
        children: appRoutes.filter(
            (r) =>
                r.menu &&
                ['LoginHistory', 'StatisticLoginHistory'].includes(r.controller)
        )
    }
];
